import type { ReactNode } from "react";
import * as stylex from "@stylexjs/stylex";
import {
  colors,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";

export type PlayRequestItem = {
  readonly id: string;
  readonly timestamp: ReactNode;
  readonly description: string;
  readonly cost: string;
};

export function PlayRequestRow({
  request,
}: {
  readonly request: PlayRequestItem;
}) {
  return (
    <div {...stylex.props(styles.request)}>
      <span {...stylex.props(styles.description)}>
        {request.timestamp} · {request.description}
      </span>
      <span {...stylex.props(styles.cost)}>{request.cost}</span>
    </div>
  );
}

const styles = stylex.create({
  request: {
    display: "flex",
    alignItems: "baseline",
    justifyContent: "space-between",
    gap: spacing.space12,
    paddingBlock: 5,
    fontSize: fontSizes.label,
    lineHeight: "19px",
  },
  description: { minWidth: 0, flex: 1, color: colors.subtle },
  cost: { flexShrink: 0, textAlign: "right", fontWeight: 500 },
});
